module.exports = __webpack_public_path__ + "static/img/video_platform3.18bc69b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/video_platform3.png
// module id = +GhS
// module chunks = 0